
exports.URL_SERVER_BACKEND = process.env.URL_SERVER_BACKEND;

exports.BACKEND_URL_QUOTATION = `${exports.URL_SERVER_BACKEND}/quotation/`;
exports.BACKEND_URL_VEHICLE = `${exports.URL_SERVER_BACKEND}/vehicle/`;
exports.BACKEND_URL_ACCOUNT = `${exports.URL_SERVER_BACKEND}/account/`;
exports.BACKEND_URL_CLIENT = `${exports.URL_SERVER_BACKEND}/client/`;
exports.BACKEND_URL_LIST_SOFTSEGUROS_CLIENTS = `${exports.URL_SERVER_BACKEND}/client/list_ss_clients/`;
exports.BACKEND_URL_LOCATION = `${exports.URL_SERVER_BACKEND}/location/`;
exports.BACKEND_URL_SOFTSEGUROS_VENDEDORES = `${exports.URL_SERVER_BACKEND}/api/vendedor/`;
exports.BACKEND_URL_SOFTSEGUROS_RAMOS = `${exports.URL_SERVER_BACKEND}/api/ramo/`;
exports.BACKEND_URL_SOFTSEGUROS_MARCA_LICENCIA = `${exports.URL_SERVER_BACKEND}/api/marca_licencia/`;
